import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { BlockedArchive } from './hooks/useArchivePostFiles';
import { postsMessages } from './postsMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostsArchiveNoticeProps {
  blocked: BlockedArchive[];
  failed: boolean;
  onOpenPost: (postUuid: string) => void;
  onClose: () => void;
}

/**
 * The answer of an archive that a live post kept (design assets-rethink c1: "A scheduled or draft
 * post keeps its file: archive asks 'Cancel the post first'"), with a link to the post in the
 * Calendar. Also the line of a call that failed.
 */
const PostsArchiveNoticeComponent: React.FC<PostsArchiveNoticeProps> = ({ blocked, failed, onOpenPost, onClose }) => {
  const intl = useIntl();
  const firstPost = blocked[0]?.postUuids[0];
  if (!failed && blocked.length === 0) {
    return null;
  }
  return (
    <Alert
      color={failed ? 'danger' : 'warning'}
      isOpen
      toggle={onClose}
      className={styles.blocked}
      data-testid="posts-archive-notice"
    >
      <span>
        {failed
          ? intl.formatMessage(postsMessages.actionFailed)
          : intl.formatMessage(postsMessages.blocked, { count: blocked.length })}
      </span>
      {!failed && firstPost !== undefined && (
        <button type="button" className={styles.link} onClick={() => onOpenPost(firstPost)}>
          {intl.formatMessage(postsMessages.blockedOpen)}
        </button>
      )}
    </Alert>
  );
};

export const PostsArchiveNotice = TypedMemo(PostsArchiveNoticeComponent);
